module.exports = __webpack_public_path__ + "cb329e885950a7c054075d78aa6f1364.svg";